<div class="actions">
  <button mat-raised-button (click)="cancelButton()">
    {{ "workorder.drawer-actions.cancel" | translate }}
  </button>
  <button
    mat-raised-button
    (click)="confirmButton()"
    [disabled]="!confirmButtonIsEnable"
  >
    {{ confirmButtonName }}
  </button>
</div>
